import { createContext } from 'react';

const DetailContext = createContext();

export default DetailContext;
